/* eslint-disable react/prop-types */
/* eslint-disable react/forbid-prop-types */
import React, { memo } from "react";
import withLazy from "../../hocs/WithLazy";

const AsyncPartnerQuoteSliderSection = withLazy(() =>
  import("./PartnerQuoteSliderSection"),
);

const PartnersThoughtSection = ({ quotes, testimonialSlide }) => {
  return (
    <section className="partners-thought-home overflow-hidden">
      <div className="container index-sub-heading">
        <div className="text-[#240253] pb-[10px] font-inter font-bold text-[26px] sm:text-[30px] md:text-[34px]">
          You&apos;re in Good Company
        </div>
        <div
          className="text-[#240253] md:mb-[20px] text-[14px] md:text-[16px] font-inter font-light leading-normal"
          style={{ maxWidth: "610px" }}>
          Trusted by 8,00,000+ Indian businesses
        </div>
        <AsyncPartnerQuoteSliderSection
          data={quotes}
          testimonialSlide={testimonialSlide}
        />
      </div>
    </section>
  );
};

export default memo(PartnersThoughtSection);
